import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

/**
 * Generic placeholder for a page whose content has not arrived yet: a
 * header bar over a row of panels.
 *
 * It stands in for the shape of a screen, not for any particular one —
 * a spinner says "wait" while leaving the page blank, and the blank is
 * what makes a load feel like a stall. Pages with a distinctive layout
 * are welcome to build their own; this is the default.
 */
export function PageSkeleton({ panels = 2, className }: { panels?: number; className?: string }) {
  return (
    <div className={cn("space-y-4", className)} role="status" aria-label="Cargando">
      <Skeleton className="h-9 w-full max-w-md rounded-lg" />
      <div className={cn("grid grid-cols-1 gap-4", panels > 1 && "md:grid-cols-2")}>
        {Array.from({ length: panels }, (_, i) => (
          <Skeleton key={i} className="h-64 rounded-xl" />
        ))}
      </div>
    </div>
  );
}
